module.exports = __webpack_public_path__ + "assets/img/pass.adb9bb13.png";